export const dynamicMenuTypes = {
    API_RESPONSE_SUCCESS: '@@menu/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@menu/API_RESPONSE_ERROR',
    GET_LIST_OF_MENUS: '@@menu/GET_LIST_OF_MENUS',
};
